document.addEventListener("DOMContentLoaded", () => {
  // Delegate the event to a parent container that won't change
  const collectionSidebar = document.querySelector("[data-main-collection]"); // Make sure this is a static container

  if (collectionSidebar) {
    collectionSidebar.addEventListener("click", function (event) {
      // Check if the clicked target is a collapsible item
      const collectionFilterDropdown = event.target.closest(
        "[data-collection-sidebar]"
      );

      if (collectionFilterDropdown) {
        const cdIcon = collectionFilterDropdown.querySelector(
          "[data-collapse-icon]"
        ); // Find the[data-collapse-icon] for the clicked element
        const cdContent = collectionFilterDropdown.querySelector(
          "[data-collapse-content]"
        ); // Find the collapsible-content for the clicked element

        console.log(collectionFilterDropdown);
        console.log(cdIcon);
        console.log(cdContent);

        // Remove 'is-open' class from all dropdowns
        const collectionFilterDropdowns = collectionSidebar.querySelectorAll(
          "[data-collection-sidebar]"
        );
        collectionFilterDropdowns.forEach((cd) => {
          const iconThis = cd.querySelector("[data-collapse-icon]");
          const contentThis = cd.querySelector("[data-collapse-content]");
          if (iconThis !== cdIcon) {
            // Ensure the clicked element is not also closed
            iconThis.classList.remove("is-open");
          }
          if (contentThis !== cdContent) {
            // Ensure the clicked element is not also closed
            contentThis.classList.remove("is-open");
            contentThis.style.height = "0"; // Corrected to set the height to 0
          }
        });

        // Add 'is-open' class to the clicked element
        cdIcon.classList.add("is-open");
        cdContent.classList.add("is-open");

        // Set the height of the clicked content to show it
        cdContent.style.height = "max-content"; // Corrected to assign height to max-content
      }
    });
  }

  const pdDesc = document.querySelector("[data-pd-description]");
  const pdShowBtn = document.querySelector("#pd-show__more");

  pdShowBtn.addEventListener("click", function () {
    // Toggle the active class on the description and the button
    pdDesc.classList.toggle("active");

    // Change the button text depending on the state
    if (pdDesc.classList.contains("active")) {
      this.querySelector(".content__").innerText = "Voir moins";
    } else {
      this.querySelector(".content__").innerText = "Voir plus";
    }

    // Toggle the button's active class to control its appearance
    this.classList.toggle("active");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // customElements.define("collection-products", CollectionProduct);

  if (document.querySelectorAll(".--variant-size")) {
    document.querySelectorAll(".--variant-size").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const { variant } = btn.dataset;

        let formData = {
          items: [
            {
              id: variant,
              quantity: 1,
            },
          ],
        };

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json();
          })
          .then((response) => {})
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            new theme.CartDrawer();
            if (document.querySelector(".js-drawer-open-cart")) {
              document.querySelector(".js-drawer-open-cart").click();
            }
            updateCartBubble();
          });
      });
    });
  }
});
// document.querySelectorAll('form[action="/en/cart/add"]').forEach((btn) => {
//   btn.addEventListener("submit", (e) => {
//     setTimeout(() => {
//       updateCartBubble(e);
//     }, 1000);
//   });
// });
